import React, { useMemo } from 'react';
import type { FC } from 'react';
import { SiteProvider } from '../../site/SiteProvider.js';
import { DevEnvironmentProvider } from './DevEnvironment.js';
import { DevCommandScreens } from './DevCommandScreens.js';
import { TunnelingConsent } from './TunnelingConsent.js';
import { RequiredAppsWarning } from './RequiredAppsWarning.js';
import { DevScreenBorder } from './DevScreenBorder.js';
import { createLogger } from '../../vite/logger.js';
import { EditorInstallation } from './EditorInstallation.js';
import { AppComponentsMigrations } from './AppComponentsMigrations.js';
import { ExtensionDataProvider } from '../../context/extensionData.js';

export const DevCommand: FC<{
  https: boolean;
  origin?: string;
  port?: number;
}> = ({ https, origin, port }) => {
  const logger = useMemo(() => createLogger({ timestamp: true }), []);

  return (
    <SiteProvider>
      <TunnelingConsent>
        <DevEnvironmentProvider
          logger={logger}
          https={https}
          origin={origin}
          port={port}
        >
          <AppComponentsMigrations>
            <EditorInstallation>
              <RequiredAppsWarning>
                <ExtensionDataProvider>
                  <DevScreenBorder>
                    <DevCommandScreens />
                  </DevScreenBorder>
                </ExtensionDataProvider>
              </RequiredAppsWarning>
            </EditorInstallation>
          </AppComponentsMigrations>
        </DevEnvironmentProvider>
      </TunnelingConsent>
    </SiteProvider>
  );
};
